import AOS from 'aos';

export default function() {
  AOS.init();
}



// WEBPACK FOOTER //
// ./source/assets/javascripts/initAos.js